import StoreIcon from '@mui/icons-material/Store';
import PersonIcon from '@mui/icons-material/Person';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { Autocomplete, Typography, TextField, ListItemText, ListItemIcon, ListItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { translate } from 'react-jhipster';

interface AccountSectionProps {
  accountOptions: any;
  selectedAccount: any;
  handleChange: (_event: any, newAccount: any) => void;
}

const titleCase = (value?: string | null) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '';

const optionSubtitle = (option: any): string =>
  [titleCase(option?.type), titleCase((option?.roles ?? [])[0])].filter(Boolean).join(' · ');

const subAccountSubtitle = (option: any): string =>
  ['Sub-account', titleCase((option?.roles ?? [])[0]), option?.inherited ? 'inherited' : '']
    .filter(Boolean)
    .join(' · ');

export const AccountSectionPresentation = ({ accountOptions, selectedAccount, handleChange }: AccountSectionProps) => {
  return (
    <Autocomplete
      sx={{ width: '270px', mx: 1 }}
      disableClearable={true}
      disablePortal={true}
      size="small"
      color="secondary"
      autoHighlight={true}
      blurOnSelect={true}
      options={accountOptions}
      value={selectedAccount}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => (
        <TextField
          key={params.id}
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <StoreIcon fontSize="medium" color="secondary" sx={{ mr: 1 }} />
                <Typography variant="subtitle1">{translate('account.account')} :</Typography>
              </>
            ),
          }}
          variant="outlined"
          placeholder="Account"
        />
      )}
      renderOption={(props, option) => {
        if (option.id === '-1') {
          return (
            <ListItem {...props} key={option.id}>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              <ListItemText primary={option.label} />
            </ListItem>
          );
        }
        const isSubAccount = Boolean(option.parentAccountId);
        return (
          <ListItem {...props} key={option.id} sx={isSubAccount ? { pl: 4 } : undefined}>
            <ListItemIcon>
              {isSubAccount ? (
                <SubdirectoryArrowRightIcon fontSize="small" />
              ) : option.type === 'PERSONAL' ? (
                <PersonIcon fontSize="small" />
              ) : (
                <StoreIcon fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText
              primary={option.label}
              secondary={isSubAccount ? subAccountSubtitle(option) : optionSubtitle(option)}
            />
          </ListItem>
        );
      }}
      onChange={handleChange}
    />
  );
};
